import React from 'react';
import type {AppProps} from 'next/app';
import {useReportWebVitals} from 'next/web-vitals';
import {appWithTranslation} from 'next-i18next';
import configNextI18Next from 'next-i18next.config';
import {config} from '@modules/config';
import dynamic from 'next/dynamic';

import {init as initSentry} from '@sentry/react';

import {ConsentContextProvider} from '@tempo/cookie';
import GTMManager from '@components/gtm-manager';

import '../styles/globals.css';

const DynamicConsentScreen = dynamic(
	() => import('@components/cookie-banner').then((mod) => mod.ConsentScreen),
	{ssr: false},
);

if (typeof window !== 'undefined' && process.env.SENTRY_DSN) {
	initSentry({
		enabled: process.env.NODE_ENV === 'production',
		dsn: process.env.SENTRY_DSN,
	});
}

const App: React.FC<AppProps> = ({Component, pageProps}) => {
	useReportWebVitals((metrics) => {
		// eslint-disable-next-line no-console
		console.log('Metric:', metrics);
	});

	React.useEffect(() => {
		if (document.domain !== 'localhost') {
			try {
				// Used for some old browsers to enable some CORS stuff
				document.domain = config.get(['host_cookie']) as string;
			} catch (error) {
				// noop
			}
		}
	}, []);

	return (
		<>
			<ConsentContextProvider>
				<GTMManager>
					<Component {...pageProps} />
					<DynamicConsentScreen />
				</GTMManager>
			</ConsentContextProvider>
		</>
	);
};

export default appWithTranslation(App, configNextI18Next);
